import type { SearchableRoute } from './useSearchableRoutes';

/** How well a route answers the query; lower ranks first. `undefined` is no match at all. */
function rankRoute(route: SearchableRoute, query: string): number | undefined {
    const label = route.label.toLowerCase();
    if (label.startsWith(query)) {
        return 0;
    }
    if (label.split(/\s+/u).some((word) => word.startsWith(query))) {
        return 1;
    }
    if (label.includes(query)) {
        return 2;
    }
    return route.path.toLowerCase().includes(query) ? 3 : undefined;
}

/**
 * The routes whose label or path holds the query, best match first: a label that starts with it,
 * then one with a word that does, then any other hit. Ties keep the order the routes are declared
 * in, so a short query that matches a lot still lists the same pages in the same order every time.
 */
export function filterRoutes(routes: SearchableRoute[], searchQuery: string): SearchableRoute[] {
    const query = searchQuery.trim().toLowerCase();
    if (!query) {
        return routes;
    }

    return routes
        .map((route) => ({ route, rank: rankRoute(route, query) }))
        .filter((match): match is { route: SearchableRoute; rank: number } => match.rank !== undefined)
        .toSorted((a, b) => a.rank - b.rank)
        .map(({ route }) => route);
}
